import { PlusCircleOutlined } from '@ant-design/icons';
import { Button, Tooltip } from 'antd';

import { TruncatedHeaderText } from '@app/shared/components';

import { ExecutorSelectBase } from '@pages/Calendar/ui/ExecutorSelect';

import { useIndividualCalendarHeader } from '../hooks';

import { IndividualCalendarHeaderSettings } from './IndividualCalendarHeaderSettings';

import type { FC } from 'react';

import '../styles/IndividualCalendarHeader.scss';

export const IndividualCalendarHeader: FC = () => {
  const {
    periodStartMoment,
    refreshCalendarData,
    returnToTodayHandler,
    executorSelectModel,
    currentEmployeeName,
    hasUserRightToAddWorkSchedule,
    handleOpenCurrentEmployeeWorkSchedule,
  } = useIndividualCalendarHeader();

  return (
    <div
      className="IndividualCalendarHeader"
      data-testid="individual-calendar-header"
    >
      <div className="IndividualCalendarHeader__section IndividualCalendarHeader__section--left">
        <div className="IndividualCalendarHeader__left-summary">
          <Button
            className="IndividualCalendarHeader__today-button"
            onClick={returnToTodayHandler}
            data-testid="individual-calendar-header-return-to-today"
          >
            К сегодня
          </Button>

          <TruncatedHeaderText
            className="IndividualCalendarHeader__employee-name"
            lineCount={3}
            text={currentEmployeeName}
            testId="individual-calendar-header-employee-name"
          />
        </div>
      </div>

      <div className="IndividualCalendarHeader__section IndividualCalendarHeader__section--center">
        <ExecutorSelectBase
          model={executorSelectModel}
          selectedDateMoment={periodStartMoment}
          refreshCalendarData={refreshCalendarData}
        />
      </div>

      <div className="IndividualCalendarHeader__section IndividualCalendarHeader__section--right">
        {hasUserRightToAddWorkSchedule && (
          <div className="IndividualCalendarHeader__action IndividualCalendarHeader__action--add-workday">
            <Tooltip title="Добавить рабочий день в расписание">
              <Button
                icon={<PlusCircleOutlined />}
                className="IndividualCalendarHeader__action-button"
                data-testid="individual-calendar-header-add-workday"
                onClick={handleOpenCurrentEmployeeWorkSchedule}
              >
                {/* {hideActionLabels ? null : 'Добавить рабочий день'} */}
              </Button>
            </Tooltip>
          </div>
        )}

        <div className="IndividualCalendarHeader__action IndividualCalendarHeader__action--settings">
          <IndividualCalendarHeaderSettings />
        </div>
      </div>
    </div>
  );
};
